import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { productsAPI, companyAPI } from '../../services/api';
import { Pencil, Trash2 } from 'lucide-react';
import toast from 'react-hot-toast';
import { useCompany } from '../common/useCompany';
import { fmtMoney, makeMoneyFormatter, getDisplayCurrency, convertAmount } from '../../utils/currency';
const fmt = fmtMoney;
export default function ProductList() {
  const navigate = useNavigate(); const [products, setProducts] = useState([]); const [loading, setLoading] = useState(true); const [search, setSearch] = useState(''); const [rates, setRates] = useState([]);
  const company = useCompany();
  const baseCurrency = company?.base_currency || getDisplayCurrency();
  const fmtBase = makeMoneyFormatter(baseCurrency);
  const load = (q = search) => { productsAPI.list({ search: q }).then(setProducts).catch(e => toast.error(e.message)).finally(() => setLoading(false)); };
  useEffect(() => { load(); }, [search]);
  useEffect(() => { companyAPI.exchangeRates().then((rs) => setRates(Array.isArray(rs) ? rs : [])).catch(() => {}); }, []);

  const rateFor = (code) => {
    if (!code || code === baseCurrency) return 1;
    const direct = rates.find(r => r.currency === code && r.to_currency === baseCurrency);
    if (direct && parseFloat(direct.rate)) return parseFloat(direct.rate);
    const reverse = rates.find(r => r.currency === baseCurrency && r.to_currency === code);
    if (reverse && parseFloat(reverse.rate)) return 1 / parseFloat(reverse.rate);
    return 1;
  };

  const doDelete = async (e, p) => {
    e.stopPropagation();
    if (!window.confirm(`Delete product "${p.name}"?`)) return;
    try {
      await productsAPI.remove(p.id);
      toast.success('Product deleted');
      load();
    } catch (err) { toast.error(err.message); }
  };

  return (
    <div>
      <div className="toolbar"><h2>Products & Services</h2>
        <div className="toolbar-right">
          <input className="form-control" placeholder="Search..." value={search} onChange={e=>setSearch(e.target.value)} style={{width:250}}/>
          <button className="btn btn-primary" onClick={()=>navigate('/products/new')}>+ New Product</button>
        </div>
      </div>
      {loading ? <div className="spinner" style={{margin:'40px auto'}} /> : (
        <div className="card"><div className="card-body" style={{padding:0}}>
          <table><thead><tr><th>SKU</th><th>Name</th><th>Type</th><th className="text-right">Cost</th><th className="text-right">Price</th><th className="text-right">Qty On Hand</th><th>Status</th><th style={{width:80}}></th></tr></thead>
            <tbody>{products.map(p=>(<tr key={p.id} onClick={()=>navigate('/products/'+p.id)} style={{cursor:'pointer'}}>
              <td className="font-mono">{p.sku}</td><td><strong>{p.name}</strong></td>
              <td><span className="badge badge-draft">{p.product_type}</span></td>
              <td className="amount">{fmt(p.purchase_cost)}{p.currency && p.currency !== baseCurrency ? <span className="text-muted" style={{fontSize:10.5, marginLeft:3}}>{p.currency}</span> : null}
                {p.currency && p.currency !== baseCurrency && p.purchase_cost > 0 && rateFor(p.currency) !== 1 && (
                  <div className="fx-sub">{fmtBase(convertAmount(p.purchase_cost, rateFor(p.currency)))}</div>
                )}
              </td><td className="amount">{fmt(p.sales_price)}{p.currency && p.currency !== baseCurrency ? <span className="text-muted" style={{fontSize:10.5, marginLeft:3}}>{p.currency}</span> : null}</td>
              <td className="text-right">{p.is_tracked ? p.quantity_on_hand : '-'}</td>
              <td>{p.is_active ? '✅' : '❌'}</td>
              <td style={{whiteSpace:'nowrap'}}>
                <button className="btn btn-ghost btn-sm" title="Edit" onClick={(e)=>{ e.stopPropagation(); navigate('/products/'+p.id); }}><Pencil size={13} /></button>
                <button className="btn btn-ghost btn-sm" title="Delete" onClick={(e)=>doDelete(e, p)}><Trash2 size={13} /></button>
              </td>
            </tr>))}
            {products.length===0 && <tr><td colSpan={8} className="text-center text-muted" style={{padding:30}}>No products found</td></tr>}
          </tbody></table>
        </div></div>
      )}
    </div>
  );
}
